<template>
    <div class="card card-custom">
        <div class="card-header">
            <h3 class="card-title">Create</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label>Category</label>
                    <select class="form-control" v-model="categoryID">
                        <option v-for="item in category" :value="item.GeneralFeedbackCategoryID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-12">
                    <label>Feedback</label>
                    <textarea class="form-control" v-model="feedback"></textarea>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="text-right">
                <button class="btn btn-success" type="button" v-on:click="saveFeedback()">Save</button>
                <button class="btn btn-danger" type="button" v-on:click="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</template>
<script>import axios from 'axios';
    export default {
        name: 'fee',
        data() {
            return {
                category: [],
                categoryID: 0,
                feedback: '',
            }
        },
        created() {
            this.pageLoad();
        },
        updated() {
        },

        methods: {
            pageLoad: function () {
                startReq();
                var vm = this;
                axios.post('/api/PortalApi/pageLoadGeneralFeedbackForm')
                    .then(function (response) {
                        endReq();
                        vm.category = response.data.lst;
                    })
            },

            saveFeedback() {
                startReq();
                var vm = this;
                axios.post('/api/PortalApi/saveGeneralFeedback?ID=' + vm.categoryID + "&feedback=" + vm.feedback)
                    .then(function (response) {
                        endReq();
                        if(response.data.status)
                            toastr.success("Save Succssfully");
                        window.location.href = "../Portal/GeneralFeedbackList";
                    })
            },

            cancel() {
                window.location.reload();
            },
        }
    }</script>



// WEBPACK FOOTER //
// src/components/school/LMS/generalFeedbackForm.vue